<template>
  <v-slider
    :value="value"
    dense
    hide-details
    class="rmr-slider"
    v-bind="$attrs"
    v-on="listeners"
  />
</template>

<script>
export default {
  name: "RmrSlider",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (v) => this.$emit("input", v),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";
</style>
